"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
exports.ResourceName = styled_1.default("span") `
  font-family: ${({ theme }) => theme.font.family.code};
  font-weight: ${({ theme, strong }) => (strong ? theme.font.weight.bold : theme.font.weight.regular)};
`;
exports.default = exports.ResourceName;
//# sourceMappingURL=ResourceName.js.map